import clsx from "clsx";
import type { NavBadgeKey } from "@/lib/navBadges";
import { NAV_BADGE_CLASS, NAV_BADGE_TITLE } from "@/lib/navBadges";

export function NavBadge({ badgeKey, count }: { badgeKey: NavBadgeKey; count: number }) {
  if (!count || count <= 0) return null;

  const title = NAV_BADGE_TITLE[badgeKey];

  return (
    <span
      className={clsx("eh-nav-badge", NAV_BADGE_CLASS[badgeKey])}
      title={title}
      aria-label={title ? `${title}: ${count > 99 ? "99+" : count}` : undefined}
      aria-live="polite"
      aria-atomic="true"
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}

export function NavBadgeGroup({
  badgeKeys,
  badgeSumKeys,
  counts,
}: {
  badgeKeys?: NavBadgeKey[];
  badgeSumKeys?: NavBadgeKey[];
  counts: Partial<Record<NavBadgeKey, number>>;
}) {
  if (badgeSumKeys?.length) {
    const sum = badgeSumKeys.reduce((acc, key) => acc + (counts[key] ?? 0), 0);
    return (
      <span className="eh-nav-badge-group">
        <NavBadge badgeKey="project-completions-open" count={sum} />
      </span>
    );
  }

  if (!badgeKeys?.length) return null;

  return (
    <span className="eh-nav-badge-group">
      {badgeKeys.map((key) => (
        <NavBadge key={key} badgeKey={key} count={counts[key] ?? 0} />
      ))}
    </span>
  );
}
